import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useUser } from "@/context/UserContext";

const InnovationContext = createContext({ overdue: 0, dueSoon: 0, refresh: () => {} });

export const InnovationProvider = ({ children }) => {
  const { currentUser } = useUser();
  const [state, setState] = useState({ overdue: 0, dueSoon: 0 });

  const refresh = useCallback(async () => {
    try {
      const s = await api.list("innovation-summary");
      setState({ overdue: s.overdue_reviews || 0, dueSoon: s.due_soon_reviews || 0 });
    } catch (err) {
      console.error("Failed to load innovation review summary:", err);
    }
  }, []);

  useEffect(() => { if (currentUser) refresh(); }, [currentUser, refresh]);

  return <InnovationContext.Provider value={{ ...state, refresh }}>{children}</InnovationContext.Provider>;
};

export const useInnovation = () => useContext(InnovationContext);
